<template>
<div class="product-card" @mouseover="onMouseOverItem" @mouseleave="onMouseLeaveItem">
    <AppLazyImg :alt="content.acf.preview_image.alt" :url="content.acf.preview_image.sizes.medium" :width="content.acf.preview_image.sizes['medium-width']" :height="content.acf.preview_image.sizes['medium-height']" :classes="['product-card__img']" :hasMask="false" />
    <div class="product-card__overlay">
        <div class="product-card__overlay__inner">

            <div class="product-card__overlay__content" :style="{'transform': `scale(${invertedScaleValue})`}">
                <router-link class="product-card__title" :to="url" v-html="content.acf.title">
                </router-link>
                <div class="product-card__links">
                    <router-link class="product-card__link link" :to="url">see</router-link>
                    <a :href="content.acf.link" target="_blank" rel="noopener" class="product-card__link link">link</a>
                </div>    
            </div>

        </div>
    </div>
</div>
</template>

<script>
import AppLazyImg from '@/components/AppLazyImg.vue'

  export default {
    name: 'AppProductCard',

    components: {
        AppLazyImg
    },

    props: {
        page: {
            type: Number,
            default: null
        },
        colIndex: {
            type: Number,
            default: null
        },

        itemIndex: {
            type: Number,
            default: null
        },

        content: {
            type: Object,
            default: null
        },
        invertScale: {
            type: Number,
            default: null
        }
    },

    data() {
      return {

      }
    },

    computed: {
        invertedScaleValue()
        {
            return this.invertScale || 1
        },

        url()
        {
            let to = { 
                name: 'product', 
                params: {id: this.content.id || this.content.ID}, 
                query: {}
            }

            if(this.colIndex !== null && this.itemIndex !== null && this.page !== null)
            {
                to.query = {
                    page: this.page,
                    col: this.colIndex,
                    item: this.itemIndex
                }
            }

            return to
        }
    },

    created()
    {

    },

    methods: {
        onMouseOverItem()
        {
            this.$el.classList.add('is-hover')
        },

        onMouseLeaveItem()
        {
            this.$el.classList.remove('is-hover')
        }
    }
  }
</script>

<style lang="stylus">
.product-card
    position relative
    display block
    overflow hidden

.product-card__img
    width 100%
    display block


.product-card:hover
    .product-card__overlay
        visibility visible
        transform translateY(0)
        transition transform 0.8s $ease-out-circ
    
    .product-card__overlay__inner
        visibility visible
        transform translateY(0)
        transition transform 0.8s $ease-out-circ
  
.product-card__overlay
    position absolute 
    top 0
    left 0
    width 100%
    height 100%
    overflow hidden
    visibility hidden
    background $white
    transform translateY(100%)
    transition transform 0.4s $ease-out-circ, visibility 0.4s

    // .is-hover &
    //     visibility visible
    //     transform translateY(0)
    //     transition transform 0.8s $ease-out-circ

.product-card__overlay__inner
    width 100%
    height 100%
    visibility hidden
    transform translateY(-100%)
    transition transform 0.4s $ease-out-circ, visibility 0.4s
    
    // .is-hover &
    //     visibility visible
    //     transform translateY(0)
    //     transition transform 0.8s $ease-out-circ

.product-card__overlay__content
    width 100%
    height 100%
    display flex
    justify-content center
    align-items center

.product-card__title
    cursor pointer
    padding 0 30px
    text-align center
    text-transform uppercase
    line-height 1.1
    interpolate('font-size', 1600px, 2560px, 25px, 35px);

    @media(max-width 1600px)
      interpolate('font-size', 768px, 1600px, 15px, 25px);

.product-card__links
    position absolute
    bottom 0
    left 0
    width 100%
    display flex
    justify-content space-between

.product-card__link
    margin 15px
    line-height 1.1
    text-transform uppercase
    interpolate('font-size', 1600px, 2560px, 20px, 25px);

    @media(max-width 1600px)
        interpolate('font-size', 768px, 1600px, 13px, 20px);
</style>